// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { DataService } from "src/app/shared/services/data.service";
import * as C from "../../../../../../shared/constants/globals.constants";

@Component({
  selector: C.EWIZ_ROUTING_INDICATOR,
  templateUrl: "./routing-indicator.component.html",
  standalone: false
})
export class EWizRoutingIndicatorComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck, ProgressCheck {
  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.errorCheck(this.profileValues, this.dataService);
  }

  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";
    const routingIndicator = values.suciEncryptionScheme.routingIndicator;
    if (dataService.isNullOrEmpty(routingIndicator)) {
      values.suciEncryptionScheme.routingIndicator = "0";
    } else if (typeof routingIndicator !== "string" || +routingIndicator < 0 || +routingIndicator > 9999) {
      this.errorMessage = $localize`Routing Indicator value must be between 0 and 9999`;
      this.errorFound = true;
    }

    return this.errorFound;
  }

  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    return !dataService.isNullOrEmpty(values.suciEncryptionScheme.routingIndicator);
  }

  override handleFormEvents(event?: any) {
    if (this.dataService.isNullOrEmpty(this.profileValues.suciEncryptionScheme.routingIndicator)) {
      this.profileValues.suciEncryptionScheme.routingIndicator = "0";
    }
    super.handleFormEvents(event);
  }
}
